import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';

import { Operation } from 'types';

import NoItemsAvailable from 'modules/_shared/components/EmptyStates/NoItemsAvailable';

import { usePartnerOperations } from '../context/PartnerOperationsContext';
import PartnerOperationsTableRow from './PartnerOperationsTableRow';

const PartnerOperationsTableBody: FC = () => {
  const { t } = useTranslate();

  const { data } = usePartnerOperations();

  const hasData = data.operations && data.operations.length > 0;

  return (
    <tbody>
      {hasData ? (
        data.operations?.map((operation: Operation, index: number) => (
          <PartnerOperationsTableRow
            key={`operation-row-${operation?._id}`}
            index={index}
            operation={operation}
          />
        ))
      ) : (
        <NoItemsAvailable
          mainMessage={t('ThisPartnerHasNoTransactions')}
          colspan={data.hasTitlesEnabled ? 11 : 10}
        />
      )}
    </tbody>
  );
};

export default PartnerOperationsTableBody;
